import type {ReactElement} from 'react';
import React from 'react';
import {AddItemButton} from '@Components/poster-editor/components/poster-add-item-bar/components/add-item-button';
import {useAppSelector} from '@/hooks';

interface DrawOptionProps {
  showDrawOption: boolean;
}
export function DrawOption({...props}: DrawOptionProps): ReactElement<any> {
  const isImageBeingGenerated = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.isImageBeingGenerated;
  });
  const isDrawModeActive = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.isDrawModeOn;
  });

  const onDrawButtonClicked = (): void => {
    window.posterEditor?.whiteboard?.drawing.updateFromObject({
      isDrawModeOn: !isDrawModeActive,
    });
  };

  return (
    <AddItemButton
      className={props.showDrawOption ? '' : '_hidden'}
      key="toolbar-draw"
      isDisabled={isImageBeingGenerated}
      onClick={onDrawButtonClicked}
      isSelected={isDrawModeActive}
      text={window.i18next.t('pmwjs_draw')}
      icon="icon-pencil"
    />
  );
}
